/* RTM-PRICEY-CTA: 売り切れ時のカートボタンをプライシー再入荷通知CTAに変える (2026-09-05)
   - 対象: button.product-form__submit[disabled] かつ文言「売り切れ」
   - クリックでプライシー(#pricey-back-in-stock-shadow-host)のモーダルを開く
   - 画面下のフローティングボタンはshadow内style注入で非表示化（モーダルは影響なし） */
(function(){
  function priceyRoot(){
    var h=document.getElementById('pricey-back-in-stock-shadow-host');
    return (h&&h.shadowRoot)?h.shadowRoot:null;
  }
  function hideFab(sh){
    if(sh.querySelector('#rtm-fab-hide')) return;
    var st=document.createElement('style');
    st.id='rtm-fab-hide';
    st.textContent='.pricey-shop-app-fab-button-container{display:none!important}';
    sh.appendChild(st);
  }
  function openModal(e){
    e.preventDefault(); e.stopPropagation();
    var sh=priceyRoot();
    var fab=sh&&sh.querySelector('.pricey-shop-app-fab-button');
    if(fab) fab.click();
  }
  function apply(){
    var sh=priceyRoot(); if(!sh) return false;
    if(!sh.querySelector('.pricey-shop-app-fab-button')) return false;
    hideFab(sh);
    var btns=document.querySelectorAll('button.product-form__submit');
    for(var i=0;i<btns.length;i++){
      var btn=btns[i];
      if(btn.dataset.rtmRestock) continue;
      if(!btn.disabled) continue;
      if((btn.textContent||'').indexOf('売り切れ')<0) continue;
      btn.dataset.rtmRestock='1';
      btn.disabled=false;
      btn.type='button';
      btn.setAttribute('aria-disabled','false');
      btn.classList.add('rtm-restock-cta');
      btn.innerHTML='<span>🔔 再入荷通知を受け取る</span>';
      btn.addEventListener('click',openModal);
    }
    return true;
  }
  var tries=0;
  var iv=setInterval(function(){ if(apply()||++tries>40) clearInterval(iv); },500);
  if(window.MutationObserver){
    new MutationObserver(function(){ apply(); }).observe(document.documentElement,{childList:true,subtree:true});
  }
})();
